<template>
  <div>
    <div v-if="products.length === 0" class="notification is-info is-size-4 has-text-centered u-p2 has-text-light has-text-weight-semibold" role="alert" aria-live="assertive">
      <b-icon icon="sad-cry" size="is-large"></b-icon>
      <br />{{ $t('search.nohit') }}
    </div>

    <DealWrapper :products="deals" :hasCountdown="true"></DealWrapper>

    <!-- <div v-if="deals.length == 1">
      <Deal :product="product" v-for="product in deals" :key="product.id" />
    </div>

    <div class="columns is-multiline is-variable is-5" v-if="deals.length > 1">
      <div class="column is-half-tablet" v-for="product in deals" :key="product.id">
        <DealSmall :product="product" />
      </div>
    </div> -->

    <div class="columns is-multiline is-variable is-5 is-block-print">
      <div class="column is-half-tablet is-one-third-desktop is-flex avoid-break-inside" v-for="product in offers" :key="product.id">
        <OfferElement :product="product" />
      </div>
    </div>
  </div>
</template>

<script>
import OfferElement from '@/components/OfferElement'
// import Deal from '@/components/Deal'
// import DealSmall from '@/components/DealSmall'
import DealWrapper from '@/components/DealWrapper'
import promotion from '@/common/promotion'
export default {
  name: 'SearchList',
  props: {
    products: {
      type: Array,
    },
  },
  components: {
    OfferElement,
    // Deal,
    // DealSmall,
    DealWrapper,
  },
  computed: {
    offers: function() {
      if (!this.products) return []
      return this.products.filter(f => !promotion.hasActivePromotion('TravelDeal', f))
    },
    deals: function() {
      if (!this.products) return []
      return this.products.filter(f => promotion.hasActivePromotion('TravelDeal', f))
    },
  },
}
</script>

<style lang="scss" scoped></style>
